import React from 'react';
import {message} from 'antd'
import { useBnsFanKuiJianChaStateMutation } from '../../store/ReactWebSiteApi';

function FeedbackState(props) {
    const [submit] = useBnsFanKuiJianChaStateMutation();
    return (
        <>
            {props.bfkjc_state==='1' ? <a 
                                    onClick={() => {
                                        submit({
                                            bfkjc_id:props.bfkjc_id,
                                            bfkjc_state:'1',
                                        }).then((res) => {
                                            //console.log(res);
                                            if (res.data.Status === 'success') {
                                                message.success('取消审核成功！')  
                                            }
                                            if (res.data.Status === 'fail') {
                                                message.error('取消审核失败！'+res.data.Message)
                                            }
                                        })
                                    }}>待实现</a>:<a  
                                        onClick={() => {
                                            submit({
                                                bfkjc_id:props.bfkjc_id,
                                                bfkjc_state:'2',
                                            }).then((res) => {
                                                //console.log(res);
                                                if (res.data.Status === 'success') {
                                                    message.success('审核成功！') 
                                                }
                                                if (res.data.Status === 'fail') {
                                                    message.error('审核失败！'+res.data.Message)
                                                }
                                            })
                                        }}>已实现</a>}
                                        
        </>
    )
}

export default FeedbackState